import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Trident1 from '../assets/TRIDENT_CAROUSEL-1.jpg'
import Trident2 from '../assets/TRIDENT_CAROUSEL-3.jpg'
import Trident3 from '../assets/TRIDENT_CAROUSEL-5.jpg'
import About from "./About";
import Contact from "./Contact";
import "./../App.css";
import Backtotop from "./Backtotop";
import Wheretobuy from "./Wheretobuy";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Helmet } from 'react-helmet'

const arrowStyles = {
  position: "absolute",
  zIndex: 2,
  // top: 'calc(50% - 15px)',
  top: "5%",
  width: "3%",
  height: "100%",
  color: "272E74",
  cursor: "pointer",
  "&hover": {
    top: 0,
    bottom: 0,
    backgroundColor: "lightgrey",
    opacity: ".4",
  },
};

function Home() {
  return (
    <div>
               <Helmet>
           <title>Trident Marine Chains</title>
         </Helmet>
      <Backtotop />
      <Carousel
        autoPlay
        transitionTime={1400}
        interval={4000}
        infiniteLoop
        showThumbs={false}
        showStatus={true}
        renderArrowPrev={(onClickHandler, hasPrev, label) =>
          hasPrev && (
            <ArrowBackIosIcon
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, left: 15 }}
            />
          )
        }
        renderArrowNext={(onClickHandler, hasNext, label) =>
          hasNext && (
            <ArrowForwardIosIcon
              onClick={onClickHandler}
              title={label}
              style={{ ...arrowStyles, right: 15 }}
            />
          )
        }
      >
        <div>
          <img src={Trident2} alt="" />
        </div>
        <div>
          <img src={Trident1} alt="" />
        </div>
        <div>
          <img src={Trident3} alt="" />
        </div>
      </Carousel>
      <Wheretobuy />
      <Contact />
      <About />
    </div>
  );
}

export default Home;
